import type {
  MarkAsReadNotificationRequestBodyDto,
  MarkAsReadNotificationResponse,
} from 'viewup-api/v2';
import type { ErrorResponse, MutationParam } from 'viewup-lib/common';
import { useSDMutation } from 'viewup-lib/react';
import { markAsReadNotification } from './mapper';

export const useMarkAsReadNotification = (
  params?: MutationParam<
    MarkAsReadNotificationResponse,
    ErrorResponse,
    MarkAsReadNotificationRequestBodyDto
  >,
) => {
  return useSDMutation<
    MarkAsReadNotificationResponse,
    ErrorResponse,
    MarkAsReadNotificationRequestBodyDto
  >({
    ...params?.options,
    mutationFn: markAsReadNotification,
  });
};
